import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RippleLoaderComponent } from '@app/lib/b2b-components/b2b-loaders/ripple-loader/ripple-loader.component';

@NgModule({
  declarations: [RippleLoaderComponent],
  imports: [CommonModule],
  exports: [RippleLoaderComponent],
})
export class B2bLoadersModule {}
